module.exports = __webpack_public_path__ + "img/m_banner.e2d8789b.png";